import React, { useEffect, useState } from "react";
import { Button } from "@wearewqa/wqa-design-system";
import { getApps } from "../../resources/apps";
import { AppData } from "../../types";
import { useAuth } from "../../hooks/auth.provider";
import { AppButton } from "../../components/AppButton";
import { CreateAppModal } from "../../modals/CreateAppModal";

export const HomePage = () => {
  const [showFrom, setShowForm] = useState<boolean>(false);
  const [data, setData] = useState<AppData[] | null>(null);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    async function buildData() {
      try {
        const apps = await getApps();
        setData(apps.body);
      } catch (error) {
        console.error("Home - buildData: ", error);
      }
    }

    void buildData();
  }, []);

  return (
    <div className="home-page">
      <div className="home-page__intro-container">
        <h1 className="home-page__header">doTERRA Mobile App Distribution</h1>
        <p className="home-page__paragraph">
          Welcome to the Mobile App Distribution Platform, where you can easily
          access and download the latest builds and previous builds for the
          doTERRA mobile apps.
        </p>
      </div>

      {isAuthenticated && (
        <div>
          <Button label={"Add App"} onClick={() => setShowForm(true)} />
          <CreateAppModal
            isOpen={showFrom}
            onClose={() => setShowForm(false)}
          />
        </div>
      )}

      <div className="home-page__apps-container">
        {data !== null ? (
          data.map((current, index) => <AppButton data={current} key={index} />)
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
